export default __webpack_public_path__ + "static/media/ABI_Logo_FullColor-Black.60947032.svg";